import { render, staticRenderFns } from "./VoipCallNotification.vue?vue&type=template&id=46e0f80c&scoped=true"
import script from "./VoipCallNotification.vue?vue&type=script&lang=js"
export * from "./VoipCallNotification.vue?vue&type=script&lang=js"
import style0 from "./VoipCallNotification.vue?vue&type=style&index=0&id=46e0f80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0f80c",
  null
  
)

export default component.exports